import { render, staticRenderFns } from "./EditSettingsServer.vue?vue&type=template&id=3cd2d882&scoped=true"
import script from "./EditSettingsServer.vue?vue&type=script&lang=js"
export * from "./EditSettingsServer.vue?vue&type=script&lang=js"
import style0 from "./EditSettingsServer.vue?vue&type=style&index=0&id=3cd2d882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd2d882",
  null
  
)

export default component.exports